import React from "react";
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const SalesOverview = ({ title, percentage, chart, isLoading }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card p='28px 10px 16px 0px' mb={{ sm: "26px", lg: "0px" }}>
      <CardHeader mb='20px' pl='22px'>
        <Flex direction='column' alignSelf='flex-start'>
          <Text
            data-testid="title"
            fontSize='lg'
            color={textColor}
            fontWeight='bold'
            mb='6px'
          >
            {isLoading ? <Skeleton width="150px" height="24px" /> : title}
          </Text>
          <Text fontSize='md' fontWeight='medium' color='gray.400'>
            {isLoading ? (
              <Skeleton width="100px" height="20px" />
            ) : (
              <>
                <Text
                  data-testid="percentage"
                  as='span'
                  color={percentage > 0 ? "green.400" : "red.400"}
                  fontWeight='bold'>
                  {`${percentage}%`} more
                </Text>{" "}
                in 2025
              </>
            )}
          </Text>
        </Flex>
      </CardHeader>
      <Box w='100%' h={{ sm: "300px" }} ps='8px' data-testid="chart-container">
        {isLoading ? <Skeleton height="300px" /> : chart}
      </Box>
    </Card>
  );
};

export default SalesOverview;
